exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".rightGridPosition {\n  margin-left: 40px;\n  margin-right: -110px;\n}\n.ui.search.dropdown > .text {\n  cursor: text;\n  position: relative;\n  left: 1px;\n  z-index: 3;\n  width: 100%;\n}\n.storage-location-list-by-buttons {\n  margin: 33px 0 0 !important;\n}\n.grid-title {\n  color: #df5a17 !important;\n  font-size: 1rem !important;\n  font-weight: bold;\n}\n.pt-50 {\n  padding-top: 50px !important;\n}\n.kitchen-item-label .ui.toggle.checkbox label {\n  font-size: 0.78571429em !important;\n  font-weight: bold !important;\n  color: rgba(0, 0, 0, 0.87);\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader!./node_modules/less-loader/dist/cjs.js!./src/styles/pages/utilities/assignentities/index.less
// module id = 3651
// module chunks = 0